export const ERRORS = {
  400: "errors.invalid", // Bad request. Client has sent something weird
  401: "errors.unverified", // Unauthenticated request. Client didn't send an auth token
  403: "errors.forbidden", // Forbidden. Client is trying to access something they shouldn't
  404: "errors.notFound", // Resource not found / doesn't exist
  418: "errors.teapot", // Use this code for a silent failure
  429: "errors.tooManyRequests", // Client is making too many requests, too quickly
  500: "errors.alert", // Something's gone wrong on the backend
};

export const MAX_REQUESTS_COUNT = 15;
export const INTERVAL_MS = 10;
export const TIMEOUT = 30000;
export const TIMEOUT_INFINITE = Infinity;
